import { createAction, handleActions } from 'redux-actions'

const openSubOrderModal = createAction('SCREENS/SUB_ORDER/OPEN_SUB_ORDER_MODAL')
const closeSubOrderModal = createAction('SCREENS/SUB_ORDER/CLOSE_SUB_ORDER_MODAL')

const defaultState = {
  show: false,
  orderTotal: null,
}

const reducer = handleActions(
  {
    [openSubOrderModal]: (state, { payload }) => ({
      ...payload,
      show: true,
    }),
    [closeSubOrderModal]: () => defaultState,
  },
  defaultState,
)

export { openSubOrderModal, closeSubOrderModal, reducer }
